import type { UnitType } from '../../lib/cogoUnits'

/** Client-side shape of a mapped Cogo artikel (from /api/cogo/maps). */
export type CogoMappedArticleDraft = {
  technicalProductId: string
  priority: number
  unitType: UnitType | null
  display: string
  assortmentUrl: string | null
  unitLabel: string | null
  weightConversionFactor: number | null
  packSize: number | null
  priceCents: number | null
  backendUnit: string | null
  unitTypes: UnitType[]
  weightStepGrams: number | null
  isBio: boolean
  favorite: boolean
  imageUrl: string | null
  hasImage: boolean
  lastEnrichedAt: string | null
}

/** Candidate artikel from enrich / /api/cogo/candidates. */
export type CogoCandidateArticle = {
  technicalProductId: string
  display: string
  assortmentUrl?: string | null
  unitLabel?: string | null
  weightConversionFactor?: number | null
  packSize?: number | null
  priceCents?: number | null
  backendUnit?: string | null
  unitTypes?: UnitType[] | null
  weightStepGrams?: number | null
  isBio?: boolean
  favorite?: boolean
  imageUrl?: string | null
  hasImage?: boolean
}

export function articleMetaLine(a: {
  unitLabel?: string | null
  packSize?: number | null
  isBio?: boolean | null
  favorite?: boolean | null
}): string {
  const pieces = a.packSize && a.packSize > 1 ? `${a.packSize}st` : null
  const unit =
    a.unitLabel &&
    pieces &&
    a.unitLabel.replace(/\s/g, '').toLowerCase() === pieces
      ? null
      : a.unitLabel
  return [unit, pieces, a.isBio ? 'BIO' : null, a.favorite ? 'favoriet' : null]
    .filter(Boolean)
    .join(' · ')
}

export function candidateToMappedDraft(
  opt: CogoCandidateArticle,
  opts?: { priority?: number; unitType?: UnitType | null }
): CogoMappedArticleDraft {
  const unitTypes = (opt.unitTypes || []).filter(
    (m): m is UnitType => m === 'P' || m === 'W' || m === 'PA'
  )
  return {
    technicalProductId: opt.technicalProductId,
    priority: opts?.priority ?? 1,
    unitType: opts?.unitType ?? null,
    display: opt.display,
    assortmentUrl: opt.assortmentUrl ?? null,
    unitLabel: opt.unitLabel ?? null,
    weightConversionFactor: opt.weightConversionFactor ?? null,
    packSize: opt.packSize ?? null,
    priceCents: opt.priceCents ?? null,
    backendUnit: opt.backendUnit ?? null,
    unitTypes,
    weightStepGrams: opt.weightStepGrams ?? null,
    isBio: Boolean(opt.isBio),
    favorite: Boolean(opt.favorite),
    imageUrl: opt.imageUrl ?? null,
    hasImage: opt.hasImage !== false,
    lastEnrichedAt: null,
  }
}
